//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { PLATFORMS, LAYOUT_TYPES } from '@/utils/constant';
import { getAstFromStr, transformer } from '@/utils/ast';
import { componentTypes, businessTypes } from './constants';
import { SEARCH_LAYOUT_LIST_PREFIX } from 'nges-common/src/constant';
// import { component } from 'vue/types/umd';
export default {
  name: 'CommonDrawer',
  components: {},
  props: {
    // formData: {
    //   type: Object,
    //   default() {
    //     return {};
    //   },
    // },
    objectId: {
      type: String,
      default: '',
    },
    objectName: {
      type: String,
      default: '',
    },
    // 相关应用
    appOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    drawerVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    // 是否为编辑布局信息
    isEdit: {
      type: Boolean,
      default: false,
    },
    // 是否为复制布局信息
    isCopy: {
      type: Boolean,
      default: false,
    },
    purposeSceneList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 类型，可选值为：
    // 元数据-对象布局    - object-layout
    // 布局管理-对象布局  - layout-manage-object
    // 布局管理-自定义布局 - layout-manage-customer
    type: {
      type: String,
      default: 'object-layout',
    },
    businessType: {
      type: String,
      default: '2',
    },
  },
  data() {
    const filteredLAYOUT_TYPES = LAYOUT_TYPES.filter((item) => item.value !== 'search');
    return {
      componentTypes,
      businessTypes,
      platformCode: 'miniprogram',
      typeCode: 'list',
      metadataList: [],
      showSelectFileds: false,
      operatorOptions: [
        { label: '加+', value: '+' },
        { label: '减-', value: '-' },
        { label: '乘*', value: '*' },
        { label: '除/', value: '/' },
        { label: '括号()', value: '()' },
        { label: '等于', value: '===' },
        { label: '不等于', value: '!==' },
        { label: '大于', value: '>' },
        { label: '大于等于', value: '>=' },
        { label: '小于', value: '<' },
        { label: '小于等于', value: '<=' },
        { label: '与', value: '&&' },
        { label: '或', value: '||' },
      ],
      functionList: [
        {
          label: '操作判断',
          options: [
            { label: '是否新增操作', value: 'IS_INSERT()' },
            { label: '是否编辑操作', value: 'IS_UPDATE()' },
          ],
        },
        {
          label: '字符串',
          options: [
            { label: '非空值判断', value: 'NOT_BLANK()' },
            { label: '正则匹配', value: 'REGEX_MATCH()' },
            { label: '字符串分隔长度 ', value: 'SPLIT_LENGTH()' },
          ],
        },
        {
          label: '聚合函数',
          options: [
            { label: '计数', value: 'COUNT()' },
            { label: '求和', value: 'SUM()' },
          ],
        },
        {
          label: '其他',
          options: [
            { label: '是否不属于', value: 'NOT_IN()' },
            { label: '格式化时间戳', value: 'FORMAT_TIMESTAMP()' },
            { label: '非空判断', value: 'NOT_NULL()' },
            { label: '是否属于', value: 'IN()' },
          ],
        },
      ],
      globalVariable: [
        { label: '当前时间戳(单位：秒)', value: 'CURRENT_TIME' },
        { label: '当前日期(0点时间戳)', value: 'CURRENT_DATE' },
        { label: '当前用户uin', value: 'CURRENT_USER_UIN' },
        { label: '当前用户岗位code', value: 'CURRENT_USER_TERRITORY' },
      ],
      // 条件报错提示配置
      conditionTips: {
        is_valid: null, // 是否通过检查
        err_code: '',
        err_msg: '', // 错误信息
      },
      rules: {
        name: [{ required: true, message: '请输入组件名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入组件Code', trigger: 'blur' }],
        type: [{ required: true, message: '请选择组件类型', trigger: 'blur' }],
        business_type: [{ required: true, message: '请选择业务类型', trigger: 'blur' }],
        component_type: [{ required: true, message: '请选择组件类型', trigger: 'blur' }],
        platform: [{ required: true, message: '请选择终端', trigger: 'change' }],
        layout_type: [{ required: true, message: '请选择布局类型', trigger: 'change' }],
      },
      localPurposeSceneList: [],
      LAYOUT_TYPES: filteredLAYOUT_TYPES,
      PLATFORMS,
      formData: {
        name: '',
        type: '',
        business_type: '',
        component_type: '',
        associated_object: '',
        is_present: false,
        platform: [],
        layout_type: [],
        associated_search_list: '',
        associated_selected_list: '',
      },
      searchList: [],
      searchLayoutList: [],
    };
  },
  computed: {
    ...mapGetters('user', ['getUserInfo', 'getTenantInfo']),
    allPurposeSceneList() {
      return [...this.localPurposeSceneList, ...this.purposeSceneList];
    },
  },
  watch: {
    drawerVisible(val) {
      if (!val) {
        this.$refs.form.resetFields();
      } else {
        this.formData.type = Number(this.businessType);
      }
    },
  },
  mounted() {
    this.getObjectList();
    this.getLayoutList();
  },
  methods: {
    // 获取布局列表
    async getLayoutList() {
      await this.$request({
        url: this.$api.getLayoutList,
        data: {
          page: 1,
          page_size: 99999999,
          appid: null,
          type: 'search',
          layout_type: 'object',
        },
      })
        .then((res) => {
          this.searchList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取元数据列表
    async getObjectList() {
      await this.$request({
        url: this.$api.metaGetObjectList,
        data: {
          keyword: '',
          object_name: '',
          offset: 0,
          limit: 99999,
          sort: 'create_time desc',
        },
      })
        .then((res) => {
          this.metadataList = res.objects;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showMetaDialog() {
      this.showSelectFileds = true;
    },
    onPurposeSceneChange(val) {
      console.log('------onPurposeSceneChange------', val);
      this.createCode(val, '');
      const idx = this.allPurposeSceneList.findIndex((item) => item.code === val);
      console.log('------idx------', idx);
      if (idx === -1) {
        this.localPurposeSceneList.push({ code: val, name: val });
      }
    },
    // 向文本框插入选择的东西
    handleInsertValue(e) {
      console.log(e);
      const selectValue = '.insert-text .el-textarea__inner';
      const dom = document.querySelector(selectValue);
      const curInsertValue =
        this.formData.pattern_rule_text.substring(0, dom.selectionStart) +
        e +
        this.formData.pattern_rule_text.substring(dom.selectionEnd, dom.textLength);
      this.$emit('handleInsert', curInsertValue);
    },
    async handleCheckGrammar() {
      const codeStr = this.formData.pattern_rule_text;
      const isValid = await this.checkStr(codeStr);
      if (!isValid) {
        return;
      }
      const ast = transformer(codeStr, this.objectName);
      try {
        const res = await this.$request({
          url: this.$api.checkValidateRule,
          data: {
            object_name: this.objectName,
            rule: JSON.stringify(ast),
          },
        });
        this.conditionTips = res;
        return this.conditionTips.is_valid;
      } catch (err) {
        console.log(err);
        this.conditionTips = {
          is_valid: false,
          err_code: '',
          err_msg: '检查不通过',
        };
      }
    },
    async checkStr(codeStr = '') {
      try {
        const { isValidAst, astErrTip } = await getAstFromStr(codeStr, this.objectName);
        // 没有通过语法检查
        if (!isValidAst) {
          const errTip = {
            is_valid: false,
            err_code: '',
            err_msg: astErrTip,
          };
          this.conditionTips = errTip;
        }
        return isValidAst;
      } catch (err) {
        const errTip = err.message || '语法检查异常';
        this.conditionTips = errTip;
        return false;
      }
    },
    // 随机生成code
    createCode(val, field, type) {
      console.log('createCode', val, field, type, this.searchList);
      if (type === 'object') {
        this.formData.associated_search_list = '';
        this.formData.associated_selected_list = '';
        this.searchLayoutList = this.searchList.filter((item) => item.object_code === val);
      }
      this.$emit('confirmCode', val, field);
    },
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        const isSuperAdmin = this.getUserInfo.uin === this.getTenantInfo.id;
        if (!isSuperAdmin) {
          if (this.formData.is_present) {
            this.$message.error('普通租户管理员不能创建预置组件');
            return;
          }
          if (this.formData.type === 1) {
            this.$message.error('普通租户管理员不能创建基础组件');
            return;
          }
        }
        const payload = {
          ...this.formData,
          platform: this.formData.platform.join(','),
          layout_type: this.formData.layout_type.join(','),
        };
        if (this.formData.associated_search_list || this.formData.associated_selected_list) {
          const filter = {};
          if (this.formData.associated_search_list) {
            filter.json = `${SEARCH_LAYOUT_LIST_PREFIX}${this.formData.associated_search_list}`;
          }
          if (this.formData.associated_selected_list) {
            filter.selected_json = `${SEARCH_LAYOUT_LIST_PREFIX}${this.formData.associated_selected_list}`;
          }
          const config = { json: { filter }, params_config: {} };
          payload.config = JSON.stringify(config);
        }
        this.$emit('handleConfirm', payload);
      });
    },
    async handleClose() {
      try {
        await this.$confirm(
          `所有${this.formData.id ? '编辑' : '新建'}内容将不做保存，确认继续？`,
          '确定要取消吗？',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );
        this.$emit('handleClose');
        this.$refs.form.resetFields();
        this.conditionTips = {
          is_valid: null, // 是否通过检查
          err_code: '',
          err_msg: '', // 错误信息
        };
      } catch (err) {
        console.log(err);
      }
    },
  },
};
